import { Injectable } from '@angular/core';
import * as Prismic from 'prismic-javascript';
import * as _ from 'lodash';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/publish';
import 'rxjs/add/operator/publishReplay';
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/mergeMap'
const apiEndpoint = "https://benderhardware.cdn.prismic.io/api/v2";



@Injectable()
export class PostsService {

  public ref:any;

  public refWrap(func) {
    if (!this.ref) {
      return this._http.get(apiEndpoint)
        .mergeMap((res: Response) => {
          let body = res.json();
          if (!(_.has(body, 'refs') && body.refs.length > 0)) {
            throw new Error('CmsService.getHome: No ref!');
          }
          this.ref = _.find(body.refs, (r) => r.id === 'master').ref;
          // console.log(res.json());
          // console.log(this.ref);
          return func();
        });

    }
    return func();
  }

  // getBlog(page: number):any {
  //   return Prismic.getApi(apiEndpoint, {}).then(function (api) {
  //     return api.query(
  //       Prismic.Predicates.at('my.post.category', 'posts'),
  //       { orderings: '[my.post.date desc]', pageSize: 12, page: page || 1 }, 
  //     );
  //     //return api.query("", {}); // An empty query will return all the documents
  //   });
  // }


  //https://benderhardware.cdn.prismic.io/api/v2/documents/search?page=1&pageSize=12&orderings=%5Bmy.post.date%20desc%5D&ref=XBuSGREAACcAZPgd&q=%5B%5Bat(my.post.category%2C%20%22posts%22)%5D%5D

  public getBlog(page: number):any {
    return this.refWrap(()=> {
      let blog = this._http.get(`https://benderhardware.cdn.prismic.io/api/v2/documents/search?page=${ page || 1 }&pageSize=12&orderings=%5Bmy.post.date%20desc%5D&ref=${ this.ref }&q=%5B%5Bat(my.post.category%2C%20%22posts%22)%5D%5D`)
      .map((res: Response) => res.json())
      //  .do(console.log)
      .publishReplay(1)
      .refCount();
      return blog;
    });


}


  public getVideos(page: number):any {
      return this.refWrap(()=> {
        let videos = this._http.get(`https://benderhardware.cdn.prismic.io/api/v2/documents/search?page=${ page || 1 }&pageSize=12&orderings=%5Bmy.post.date%20desc%5D&ref=${ this.ref }&q=%5B%5Bat(my.post.category%2C%20%22videos%22)%5D%5D`)
        .map((res: Response) => res.json())
        //  .do(console.log)
        .publishReplay(1)
        .refCount();
        return videos;
      });


  }

  getHistoryList():any {

    return new Promise((resolve, reject)=>{
      let posts = [];
      
      Prismic.getApi(apiEndpoint, {}).then(function (api) {
        api.query(
          Prismic.Predicates.at('document.type', 'history'),
          { orderings: '[my.history.history_date]', pageSize: 100, page: 1 }
        ).then((result:any)=>{
          console.log("getHistoryList: ", result);
          
          posts = result.results;
          let page = result.page;
          let total = result.total_pages;
          if (page < total) {
            console.log("page < total");
            let promises = [];
            for (var i = page + 1; i <= total; i++) {
              promises.push(new Promise((_resolve, _reject)=>{
                api.query(
                  Prismic.Predicates.at('document.type', 'history'),
                  { orderings: '[my.history.history_date]', pageSize: 100, page: i }
                ).then((result:any)=>{
                  posts = posts.concat(result.results);
                  _resolve(result.results);
                }).catch(_reject);
              }));
             
              Promise.all(promises).then(()=>{
                resolve(posts);
              });
              

            }
          } else {
            resolve(posts);
          }
          // if (result.) {}
        }).catch((err)=>{
          console.error("getHistoryList: ", err);
          reject(err);
        });
      }).catch(reject);
    });

    
  }

  getHistory_old(page: number):any {
    return Prismic.getApi(apiEndpoint, {}).then(function (api) {
      return api.query(
        Prismic.Predicates.at('my.post.category', 'history'),
        { orderings: '[my.post.date desc]', pageSize: 12, page: page || 1 }, 
      );
      //return api.query("", {}); // An empty query will return all the documents
    });
  }

  getHistory(id: string):any {
    return Prismic.getApi(apiEndpoint, {}).then(function (api) {
      return api.getByUID('history', id, {'fetchLinks': []
      // ['post.title', 'video.title', 'team.title', 'team.featured_image', 'post.featured_image', 'video.featured_image', 'post.snippet', 'video.snippet', 'team.snippet']
    });
    });
  }
  
  
  
  

  // getFeatured():any {
  //   return Prismic.getApi(apiEndpoint, {}).then(function (api) {
  //     return api.getSingle('features', {'fetchLinks': 
  //     ['history.featured_image', 'history.title', 'history.snippet', 'post.category', 'post.title', 'video.title', 'team.title', 'team.featured_image', 'post.featured_image', 'video.featured_image', 'post.snippet', 'video.snippet', 'team.snippet']
  //   });
  //   });
  // }

  public getFeatured():any {
    return this.refWrap(()=> {
      let featured = this._http.get(`https://benderhardware.cdn.prismic.io/api/v2/documents/search?page=1&pageSize=1&fetchLinks=history.featured_image%2Chistory.title%2Chistory.snippet%2Cpost.category%2Cpost.title%2Cvideo.title%2Cteam.title%2Cteam.featured_image%2Cpost.featured_image%2Cvideo.featured_image%2Cpost.snippet%2Cvideo.snippet%2Cteam.snippet&ref=${ this.ref }&q=%5B%5Bat(document.type%2C%20%22features%22)%5D%5D`)
      .map((res: Response) => res.json().results)
      //  .do(console.log)
      .publishReplay(1)
      .refCount();
      return featured;
    });


 }



public getPost(type: string, id: string):any {
  return this.refWrap(()=> {
    let featured = this._http.get(`https://benderhardware.cdn.prismic.io/api/v2/documents/search?page=1&pageSize=1&fetchLinks=post.category%2Cpost.title%2Cvideo.title%2Cteam.title%2Cteam.featured_image%2Cpost.featured_image%2Cvideo.featured_image%2Cpost.snippet%2Cvideo.snippet%2Cteam.snippet&lang=*&ref=${ this.ref }&q=%5B%5Bat(my.post.uid%2C%20%22${ id }%22)%5D%5D`)
    .map((res: Response) => res.json().results)
    //  .do(console.log)
    .publishReplay(1)
    .refCount();
    return featured;
  });


}


  // getPost(type: string, id: string):any {
  //   return Prismic.getApi(apiEndpoint, {}).then(function (api) {
  //     return api.getByUID(type, id, {'fetchLinks': 
  //     ['post.category', 'post.title', 'video.title', 'team.title', 'team.featured_image', 'post.featured_image', 'video.featured_image', 'post.snippet', 'video.snippet', 'team.snippet']
  //   });
  //   });
  // }

  getTeam():any {
    return Prismic.getApi(apiEndpoint, {}).then(function (api) {
      return api.query(
        Prismic.Predicates.at('document.type', 'team'),
        { orderings: '[my.team.date desc]' }
      );
    });
  }

  // getVideos(page: number):any {
  //   return Prismic.getApi(apiEndpoint, {}).then(function (api) {
  //     return api.query(
  //       Prismic.Predicates.at('my.post.category', 'videos'),
  //       { orderings: '[my.post.date desc]', pageSize: 12, page: page || 1 }, 
  //     );
  //     //return api.query("", {}); // An empty query will return all the documents
  //   });
  // }

  

  constructor(private _http:Http) { }

  ngOnInit() {
    this.getFeatured();
  }

}



// WEBPACK FOOTER //
// /tmp/build_fdb7fa8d/src/app/posts.service.ts